<template>
  <FormInputWrapper :error="error" :label="label" :note="note" :required="required">
    <SelectBox v-bind="$attrs" :default-value="defaultValue" :disabled="disabled" :is-error="isError" :model-value="modelValue" :options="options" />
  </FormInputWrapper>
</template>

<script setup lang="ts">
import type { Options } from '@/models/option';
import { SelectBox, FormInputWrapper } from '@/wabunka-src/common/components';

interface Props {
  label?: string;
  note?: string;
  required?: boolean;
  error?: string;
  options?: Options;
  modelValue: string | number;
  defaultValue?: string | number;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  label: undefined,
  note: '',
  required: true,
  error: '',
  options: () => [],
  modelValue: '',
  defaultValue: '',
  disabled: false,
});

const isError = computed(() => !!props.error && props.error !== '');
</script>
